import mainContentApi from "../api/main-content-api";

const edit = async (payload) => {
    const resp = await mainContentApi.edit(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const search = async () => {
	try {
		const result = await mainContentApi.search();
		return { bean: result.bean };
	} catch (err) {
		console.error(err);
		throw err;
	}
};

const mainContentService = {
    edit,
    search
};

export default mainContentService;